import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { motion } from 'framer-motion';
import { FaMapPin } from 'react-icons/fa';
import '../style/HeroSection.css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

export default function HeroSection() {
  const heroVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const captionVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.3 } },
  };

  const slidesData = [
    {
      imgSrc: '/images/rooms/ro1.jpg',
      location: '568 E 1st Ave, Miami',
      price: '$550 / Month',
      size: '550 SqFt',
      beds: '6 Beds',
      baths: '4 Baths',
      garages: '3 Garages',
    },
    {
      imgSrc: '/images/rooms/ro2.jpg',
      location: '1234 W 5th St, Los Angeles',
      price: '$600 / Month',
      size: '600 SqFt',
      beds: '5 Beds',
      baths: '4 Baths',
      garages: '2 Garages',
    },
    {
      imgSrc: '/images/rooms/ro3.jpg',
      location: '789 N 7th Ave, San Francisco',
      price: '$700 / Month',
      size: '700 SqFt',
      beds: '4 Beds',
      baths: '3 Baths',
      garages: '2 Garages',
    },
    {
      imgSrc: '/images/rooms/ro4.jpg', // Map image for slide 4
      location: '456 S 3rd Blvd, Chicago',
      price: '$750 / Month',
      size: '750 SqFt',
      beds: '4 Beds',
      baths: '4 Baths',
      garages: '3 Garages',
    },
    {
      imgSrc: '/images/rooms/ro5.jpg', // Map image for slide 5
      location: '321 N 9th St, New York',
      price: '$800 / Month',
      size: '800 SqFt',
      beds: '5 Beds',
      baths: '4 Baths',
      garages: '2 Garages',
    },
    {
      imgSrc: '/images/rooms/ro6.jpg', // Map image for slide 6
      location: '1122 W 4th Ave, Boston',
      price: '$850 / Month',
      size: '850 SqFt',
      beds: '6 Beds',
      baths: '5 Baths',
      garages: '3 Garages',
    }
  ];

  return (
    <motion.div
      className="relative"
      style={{ height: '600px' }}
      initial="hidden"
      animate="visible"
      variants={heroVariants} // Apply animation to the whole section
    >
      <Swiper
        spaceBetween={50}  // Space between slides
        slidesPerView={1}  // Show one slide at a time
        loop={true}  // Infinite loop
        autoplay={{
          delay: 3000,  // Auto slide interval (3 seconds)
          disableOnInteraction: false,  // Keeps autoplay even after interaction
        }}
        navigation={true}  // Show navigation arrows
        pagination={false}   // Show pagination dots
        modules={[Navigation]}
      >
        {slidesData.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="swiper-slide-image" style={{ position: 'relative' }}>
              <img
                className="d-block w-100"
                src={slide.imgSrc}
                alt="Property"
                style={{ height: '600px', objectFit: 'cover' }}
              />
              <motion.div
                className="swiper-caption text-center"
                initial="hidden"
                animate="visible"
                variants={captionVariants} // Apply animation to the caption
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  bottom: '0',
                  transform: 'translateX(-50%)',
                  color: 'white',
                  zIndex: 10,
                  width: '100%'
                }}
              >
                <div className="d-flex bg-slider-custom align-items-center justify-content-center h-100 flex-column w-100">
                  <h1 className="display-4 fw-bold mb-4">Friuli-Venezia Giulia</h1>
                  <div className="d-flex justify-content-center align-items-center gap-2 mb-4">
                    <FaMapPin className="w-6 h-6" />
                    <span className="fs-5">{slide.location}</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
                    <span className="bg-warning text-dark px-4 py-2 rounded-pill fw-bold">
                      FOR RENT
                    </span>
                    <span className="fs-2 fw-bold">
                      {slide.price}
                    </span>
                  </div>
                  <div className="d-flex justify-content-center flex-wrap gap-5 fs-4">
                    <div>{slide.size}</div>
                    <div>{slide.beds}</div>
                    <div>{slide.baths}</div>
                    <div>{slide.garages}</div>
                  </div>
                </div>
              </motion.div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </motion.div>
  );
}
